/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Opacity_AriaInputs */



/**
* | output |
* | --- |
* | "Text Opacity" |
*
* @param {Video_Export_Opacity_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_opacity_aria = /** @type {((inputs?: Video_Export_Opacity_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Opacity_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Opacite du texte")
	if (locale === "de") return /** @type {LocalizedString} */ ("Textdeckkraft")
	if (locale === "it") return /** @type {LocalizedString} */ ("Opacità del testo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Прозрачность текста")
	if (locale === "es") return /** @type {LocalizedString} */ ("Opacidad del texto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("文本不透明度")
	if (locale === "ja") return /** @type {LocalizedString} */ ("テキストの不透明度")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पाठ अपारदर्शिता")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Opacidade do texto")
	return /** @type {LocalizedString} */ ("Text Opacity")
});